import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, useMultiStyleConfig, useStyleConfig, useMediaQuery} from '@chakra-ui/react'
import {Navigation, Pagination, Keyboard} from 'swiper/modules'
import {Swiper, SwiperSlide} from 'swiper/react'
import {GalleryChevronRightIcon, GalleryChevronLeftIcon} from '../../icons'
import {remCalc} from '../../../theme/_utils'
import {HideOnDesktop} from '@salesforce/retail-react-app/app/components/responsive'

import MoodBoardCard from './partials/moodboard-card'

export const Moodboard = ({hasPaddings, moodboardGroup}) => {
    const swiperStyles = useStyleConfig('Swiper')

    const [isMobile] = useMediaQuery(`(max-width: ${remCalc(449)})`)
    const [isSmallTablet] = useMediaQuery(
        `(min-width: ${remCalc(450)}) and (max-width: ${remCalc(768)})`,
    )

    const styles = useMultiStyleConfig('Moodboard', {
        isSmallTablet,
        slidersLength: moodboardGroup?.length,
        hasPaddings,
    })

    const slidesToView = {
        base: 1.14,
        sm: moodboardGroup?.length > 2 ? 2.4 : 2,
        md: moodboardGroup?.length > 2 ? 2.45 : 2,
        lg: moodboardGroup?.length ?? 4,
    }

    if (!moodboardGroup || moodboardGroup?.length === 0) return null

    return (
        <Box
            __css={{...swiperStyles, ...styles.container, ...styles.outterCardContainer}}
            data-testid="category-moodboard-container"
        >
            <Swiper
                key={isMobile ? 'mobile-view' : 'other-view'}
                modules={[Navigation, Pagination, Keyboard]}
                navigation={{
                    prevEl: `.swiper-button-prev`,
                    nextEl: `.swiper-button-next`,
                }}
                pagination={{
                    clickable: true,
                    el: '.promo-slider-pagination',
                }}
                keyboard={{
                    enabled: true,
                }}
                loop={true}
                enabled={true}
                // onSlideChange={handleSlideChange}
                breakpoints={{
                    0: {
                        slidesPerView: slidesToView.base,
                        enabled: true,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: slidesToView.md,
                        enabled: moodboardGroup.length > 2,
                        spaceBetween: 16,
                    },
                    1024: {
                        slidesPerView: slidesToView.md,
                        spaceBetween: 24,
                        enabled: false,
                    },
                    1440: {
                        slidesPerView: slidesToView.lg,
                        spaceBetween: 0,
                        enabled: false,
                    },
                }}
            >
                {moodboardGroup.map((slider, index) => (
                    <SwiperSlide key={index}>
                        <MoodBoardCard
                            textBlock={slider?.text_block}
                            images={slider?.images}
                            cta={slider?.button}
                        />
                    </SwiperSlide>
                ))}
                {isMobile && <Box className="promo-slider-pagination" />}
                <HideOnDesktop>
                    {(isMobile || moodboardGroup.length > 2) && (
                        <>
                            <Flex
                                className="swiper-button-prev"
                                aria-label="swiper button prev icon"
                                {...styles.chevronIcon}
                                left={
                                    isSmallTablet ? remCalc(4) : {base: remCalc(16), md: remCalc(8)}
                                }
                            >
                                <GalleryChevronLeftIcon boxSize={remCalc(16)} aria-hidden="true" />
                            </Flex>

                            <Flex
                                className="swiper-button-next"
                                aria-label="swiper button next icon"
                                {...styles.chevronIcon}
                                right={isSmallTablet ? '14%' : {base: remCalc(29), md: '16%'}} //16.5%
                            >
                                <GalleryChevronRightIcon boxSize={remCalc(16)} aria-hidden="true" />
                            </Flex>
                        </>
                    )}
                </HideOnDesktop>
            </Swiper>
        </Box>
    )
}

Moodboard.propTypes = {
    hasPaddings: PropTypes.bool,
    moodboardGroup: PropTypes.arrayOf(
        PropTypes.shape({
            text_block: PropTypes.shape({
                title: PropTypes.string,
                body_copy: PropTypes.string,
            }),
            cta: PropTypes.shape({title: PropTypes.string, href: PropTypes.string}),
            images: PropTypes.object,
        }),
    ),
}
